/**
 * The `(IN)` annotation appended to a dimension when its surface is measured in inches.
 *
 * Encodes a non-obvious business rule in one place: the suffix marks that the *surface* uses
 * inches, so it is shown regardless of whether the displayed value was overridden. Metric
 * quotes don't use the feet/inches toggle, so they are never annotated.
 */
export function getInchSuffix({ useInches, unitValue }: { useInches?: boolean; unitValue?: string }): string {
  return useInches && unitValue !== 'Metre' ? ' (IN)' : ''
}
